import React from "react";
import {
  EActiveDrawer,
  EInteractionMode,
  ESubMenu,
  EToolbarButton,
  EWallMode
} from "../../../../@types/Enums";
import { useSelection } from "../../../../provider/SelectionProvider";
import { useToolbarContext } from "../../../../provider/ToolbarProvider";
import ToolbarButton, { ToolbarButtonProps } from "../ToolbarButton";

export interface MeasureButtonProps extends ToolbarButtonProps {
  handleToolbarButtonPress: (
    buttonId: EToolbarButton, 
    subMenuType?: ESubMenu, 
    activatedDrawer?: EActiveDrawer
  ) => void;
}

const MeasureButton: React.FC<MeasureButtonProps> = (props) => {
  const {
    interactionMode,
    setInteractionMode,
    setWallMode,
    setCurrentlyActiveSubMenu,
    setIsDrawingAllowed,
  } = useToolbarContext();
  const { setActiveDrawer } = useSelection();
  const { handleToolbarButtonPress } = props;

  const handleClick = () => {
    // Reset conflicting modes
    setWallMode(EWallMode.NONE);
    setActiveDrawer(EActiveDrawer.NONE);
    setCurrentlyActiveSubMenu(ESubMenu.NONE);
    setIsDrawingAllowed(false);

    if (interactionMode === EInteractionMode.MEASURE) {
      setInteractionMode(EInteractionMode.NONE);
      handleToolbarButtonPress(EToolbarButton.MEASURE, ESubMenu.NONE, EActiveDrawer.NONE);
    } else {
      handleToolbarButtonPress(EToolbarButton.MEASURE, ESubMenu.NONE, EActiveDrawer.NONE);
      setInteractionMode(EInteractionMode.MEASURE);
    }
  };

  return (
    <ToolbarButton
      {...props}
      onClick={handleClick}
      active={interactionMode === EInteractionMode.MEASURE}
    />
  );
};

export default MeasureButton;
